<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-10 13:47:54
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-28 15:42:01
 * @FilePath: \hzs-nutra-wecom-shop\src\views\customer\customerList.vue
 * @Description: 我的客户 - 客户列表
-->

<template>
  <div class="page-container">
    <div class="mainContent">
      <van-tabs v-model:active="state.activeName" @click-tab="onClickTab">
        <van-tab title="我的小程序客户" name="mini"></van-tab>
        <van-tab title="我的企微好友" name="qw"></van-tab>
      </van-tabs>

      <div class="tips">
        <p class="tip1">
          小程序客户总数：{{
            state.statistics?.wx_user_bind_count || 0
          }}人，已绑定企微：{{
            state.statistics?.we_com_user_bind_count || 0
          }}人
        </p>
        <p class="tip2">
          截止：{{ state.statistics?.data_time || state.today }}
        </p>
      </div>

      <dis class="searchBox flex align-center">
        <div class="inputBox flex align-center justify-sb">
          <van-icon name="search" color="#B3B3B3" size="24" />

          <input
            type="text"
            v-model="state.query_condition"
            class="flex-1"
            placeholder="请输入客户名称或手机号搜索"
            @update:model-value="handleSearch"
          />
        </div>

        <i class="filterIcon"></i>
      </dis>

      <!-- <van-pull-refresh
        v-if="state.listData.length"
        v-model="state.isRefresh"
        pull-distance="80"
        @refresh="onRefresh"
      >
        <van-list
          v-model:loading="state.listLoading"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="item in state.listData"
            :key="item?.user?.uuid || item.user_uuid"
            class="customerItem"
            @click="goto(item)"
          >
            <div class="up flex align-center justify-sb">
              <div class="leftBox flex align-center">
                <img
                  :src="
                    item?.user?.wx_user?.avatar_url ||
                    item?.we_com_ext_user_avatar_url ||
                    EmptyHeadImg
                  "
                  class="img"
                  alt=""
                />

                <div class="msg">
                  <div class="name">
                    {{ item?.user?.name || item?.we_com_user_name }}
                  </div>
                  <div class="gOrA">
                    {{ getGender(item?.user?.sex || item?.we_com_user_sex) }}
                    {{ getAge(item?.user?.birthday || item?.birthday) }}岁
                  </div>
                </div>
              </div>

              <div class="iconBox flex align-center">
                <template v-if="item?.user?.wx_user">
                  <i class="icon db wechatIcon"></i>
                </template>
                <template v-if="item?.user?.wx_user?.wecom_external_user">
                  <i class="icon db weComIcon"></i>
                </template>
              </div>
            </div>

            <div class="down flex align-center justify-sb">
              <div class="phone">
                手机号码：{{ item?.user?.phone || item?.wx_user_phone }}
              </div>
              <i class="icon telephoneIcon db"></i>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <div v-else class="emptyBox flex align-center justify-sc">
        <van-empty
          :image="emptyCustomerImg"
          image-size="150"
          description="没有该客户？去创建新客户"
        />
      </div> -->

      <div class="pageList">
        <PullAndPush_list
          v-if="isDataReady"
          ref="listRef"
          :request="
            state.activeName == 'mini'
              ? CustomerApi._customerList
              : state.activeName == 'qw'
                ? CustomerApi._customerList2
                : null
          "
          :otherParams="otherParams"
        >
          <template #default="{ list }">
            <div
              v-for="item in list"
              :key="item?.user?.uuid || item.user_uuid"
              class="customerItem"
              @click="goto(item)"
            >
              <div class="up flex align-center justify-sb">
                <div class="leftBox flex align-center">
                  <img
                    :src="
                      item?.user?.wx_user?.avatar_url ||
                      item?.we_com_ext_user_avatar_url ||
                      EmptyHeadImg
                    "
                    class="img"
                    alt=""
                  />

                  <div class="msg">
                    <div class="name">
                      {{ item?.user?.name || item?.we_com_user_name }}
                    </div>
                    <div class="gOrA">
                      {{ getGender(item?.user?.sex || item?.we_com_user_sex) }}
                      {{ getAge(item?.user?.birthday || item?.birthday) }}岁
                    </div>
                  </div>
                </div>

                <div class="iconBox flex align-center">
                  <template v-if="item?.user?.wx_user">
                    <i class="icon db wechatIcon"></i>
                  </template>
                  <template v-if="item?.user?.wx_user?.wecom_external_user">
                    <i class="icon db weComIcon"></i>
                  </template>
                </div>
              </div>

              <div class="down flex align-center justify-sb">
                <div class="phone">
                  手机号码：{{ item?.user?.phone || item?.wx_user_phone }}
                </div>
                <i class="icon telephoneIcon db"></i>
              </div>
            </div>
          </template>
        </PullAndPush_list>
      </div>
    </div>

    <div class="bottom_button_box">
      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        class="save-btn"
        v-if="
          pageType === 1 && state.activeName == 'mini' && state.isShopManage
        "
        @click="handleViewData(2)"
      >
        查看门店客户
      </van-button>
      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        class="save-btn"
        v-if="
          pageType === 2 && state.activeName == 'mini' && state.isShopManage
        "
        @click="handleViewData(1)"
      >
        查看我的客户
      </van-button>

      <van-button
        round
        block
        type="primary"
        class="save-btn"
        color="#DCBB89"
        v-if="pageType === 1 && state.activeName == 'qw' && state.isShopManage"
        @click="handleViewData(2)"
      >
        查看门店企微好友
      </van-button>
      <van-button
        round
        block
        type="primary"
        class="save-btn"
        color="#DCBB89"
        v-if="pageType === 2 && state.activeName == 'qw' && state.isShopManage"
        @click="handleViewData(1)"
      >
        查看我的企微好友
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import dayjs from "dayjs";
import {
  ref,
  reactive,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
  nextTick,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import CustomerApi from "@/utils/api/customer";
import emptyCustomerImg from "@/assets/img/customer/emptyCustomer.png";
import EmptyHeadImg from "@/assets/img/icons/emptyHeadImg.png";

// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();

/**
 * pageType: 1-我的客户 2-门店客户
 */
const pageType = ref(Number(route.query.type));

let shop_clerk_uuid: string | null | undefined = undefined;
let shop_uuid: string | null | undefined = undefined;
let isDataReady = ref(false);
const state = reactive({
  activeName: "mini",
  today: dayjs().format("MM-DD HH:mm"),

  // 是否是店长
  isShopManage: true,

  query_condition: undefined,

  listData: [] as any[],

  statistics: {},

  pagination: {
    page: 1,
    lastPage: 1,
    pageSize: 10,
    lastPageSize: 1,
    total: 0,
  },

  isRefresh: false,
  finished: true,
  listLoading: false,
});
const otherParams = computed(() => {
  let res: any = {
    query_condition: state.query_condition,
    page: state.pagination.page,
    page_size: state.pagination.pageSize,
    shop_clerk_uuid_not_required: false,
  };
  if (state.activeName == "mini") {
    res["shop_clerk_uuid"] = pageType.value == 1 ? shop_clerk_uuid : undefined;
    res["shop_uuid"] = pageType.value == 1 ? undefined : shop_uuid;
  } else if (state.activeName == "qw") {
    res["shop_clerk_uuid"] = pageType.value === 1 ? shop_clerk_uuid : undefined;
    res["shop_uuid"] = shop_uuid;
  }

  return res;
});
const listRef = ref<any>(null);
// --------------------------------------- 方法、事件
onMounted(async () => {
  shop_clerk_uuid = localStorage.getItem("shop_clerk_uuid");
  shop_uuid =
    JSON.parse(localStorage.getItem("departmentdata") as string)
      ?.department_uuid || undefined;

  await nextTick();
  isDataReady.value = true;
  //   GroupService.getData();

  GroupService.getStatistics();
});

const getGender = (gender: number | string) =>
  ({
    1: "男",
    2: "女",
    3: "",
  })[gender] || "";

function getAge(birthday) {
  return dayjs().diff(dayjs(birthday), "year");
}

// 切换 小程序客户/企微好友
async function onClickTab() {
  await nextTick();
  //   GroupService.getData();
  listRef.value?.reloadCurrentPage();
  GroupService.getStatistics();
}

// // 下拉刷新 -回调
// const onRefresh = async () => {
//   // 重置列表状态
//   state.isRefresh = true;
//
//   state.listData = [];
//
//   state.pagination.lastPage = state.pagination.page;
//   state.pagination.lastPageSize = state.pagination.pageSize;
//
//   state.pagination.page = 1;
//   state.pagination.pageSize =
//     state.pagination.lastPage * state.pagination.lastPageSize;
//
//   //   await GroupService.getData();
//   listRef.value?.reloadCurrentPage();
//   await nextTick();
//   state.isRefresh = false;
//   state.pagination.pageSize = state.pagination.lastPageSize;
// };
//
// // 上拉加载 -回调 (由 van-list 触发)
// const onLoad = async () => {
//   if (state.listData.length < state.pagination.total) {
//     state.pagination.page += 1;
//     // await GroupService.getData();
//     listRef.value?.reloadCurrentPage();
//   }
// };

let timer_: any = null; // 定时器引用
function handleSearch() {
  // 防抖处理：用户停止输入 500ms 后再请求
  if (timer_) clearTimeout(timer_);
  timer_ = setTimeout(async () => {
    // GroupService.getData();
    listRef.value?.reloadCurrentPage();
  }, 1000); // 1000毫秒延迟
}

// 切换查看 我的客户/门店客户
async function handleViewData(_type: number) {
  pageType.value = _type;

  await nextTick();
  //   GroupService.getData();
  listRef.value?.reloadCurrentPage();
  GroupService.getStatistics();
}

// 跳转详情页
function goto(row) {
  router.push({
    path: "/customerDetail",
    query: {
      user_uuid: row.user_uuid || row?.user?.uuid,
      unionid: row?.user?.union_id,
      type: state.activeName,
    },
  });
}

// --------------------------------------- 请求
const GroupService = {
  async getData() {
    const params: any = {
      query_condition: state.query_condition,
      page: state.pagination.page,
      page_size: state.pagination.pageSize,
      shop_clerk_uuid_not_required: false,
    };

    let api = null;
    if (state.activeName == "mini") {
      params["shop_clerk_uuid"] =
        pageType.value == 1 ? shop_clerk_uuid : undefined;
      params["shop_uuid"] = pageType.value == 1 ? undefined : shop_uuid;

      api = CustomerApi._customerList;
    } else if (state.activeName == "qw") {
      params["shop_clerk_uuid"] =
        pageType.value === 1 ? shop_clerk_uuid : undefined;
      params["shop_uuid"] = shop_uuid;

      api = CustomerApi._customerList2;
    }
    let res = await api(JSON.parse(JSON.stringify(params))).catch(() => {
      state.listLoading = false;
    });
    if (res?.code === 200) {
      const newData = res?.data || [];
      const total = res?.total || res?.cnt || 0;

      state.pagination.total = total;

      // 累加数据逻辑
      if (state.pagination.page === 1) {
        // 第一页直接覆盖 (刷新场景)
        state.listData = newData;
      } else {
        // 非第一页追加 (上拉场景)
        state.listData = [...state.listData, ...newData];
      }

      // 【关键判断】是否设置 finished
      if (state.listData.length >= state.pagination.total) {
        state.finished = true;
      } else {
        state.finished = false;
      }
    }
    let timer: any = setTimeout(() => {
      state.listLoading = false;

      clearTimeout(timer);
      timer = null;
    }, 500);
  },

  // 获取统计信息
  async getStatistics() {
    const params = {
      shop_clerk_uuid: pageType.value == 1 ? shop_clerk_uuid : undefined,
      shop_uuid: shop_uuid,

      shop_clerk_uuid_not_required: false,
    };
    let api = null;
    if (state.activeName == "mini") {
      api = CustomerApi._customerMiniStatistics;
    } else if (state.activeName == "qw") {
      api = CustomerApi._customerQWStatistics;
    }
    let res = await api(JSON.parse(JSON.stringify(params))).catch((err) => {});
    if (res?.code === 200) {
      state.statistics = res?.data || {};
    }
  },
};
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.mainContent {
  padding: 0;

  .icon {
    width: 28px;
    height: 28px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    &.wechatIcon {
      background-image: url("@/assets/img/icons/wechat-ico.png");
    }
    &.weComIcon {
      background-image: url("@/assets/img/icons/wecom-ico.png");
    }
    &.telephoneIcon {
      background-image: url("@/assets/img/icons/phoneicon-1.png");
    }
  }

  .van-tabs {
    height: 52px;

    :deep(.van-tabs__wrap) {
      height: 100% !important;

      .van-tab__text {
        height: 22px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .van-tab--active .van-tab__text {
        font-weight: 600;
        font-size: 16px;
        color: #333333;
      }

      .van-tabs__line {
        background: #dcbb89;
      }
    }
  }

  .tips {
    height: 70px;
    padding: 10px 18px;
    background: rgba(220, 187, 137, 0.12);

    p {
      height: 25px;
      line-height: 25px;

      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;

      &.tip1 {
      }
      &.tip2 {
        font-weight: 500;
        font-size: 14px;
      }
    }
  }

  .searchBox {
    height: 66px;
    padding: 10px 18px;
    background: #ffffff;

    .inputBox {
      width: calc(100% - 42px);
      height: 45px;
      padding: 11px;
      background: #f6f6f6;
      border-radius: 8px;

      input {
        flex: 1;
        width: calc(100% - 24px - 8px);
        height: 100%;
        border: none;
        outline: none;
        background: transparent;

        color: #999;
        font-weight: 400;
        font-size: 14px;
      }
      /* WebKit browsers */
      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #999;
        font-weight: 400;
        font-size: 14px;
      }
      /* Mozilla Firefox 4 to 18 */
      input:-moz-placeholder,
      textarea:-moz-placeholder {
        color: #999;
        font-weight: 400;
        font-size: 14px;
      }
      /* Mozilla Firefox 19+ */
      input::-moz-placeholder,
      textarea::-moz-placeholder {
        color: #999;
        font-weight: 400;
        font-size: 14px;
      }
      /* Internet Explorer 10+ */
      input:-ms-input-placeholder,
      textarea:-ms-input-placeholder {
        color: #999;
        font-weight: 400;
        font-size: 14px;
      }
    }

    .filterIcon {
      display: block;
      width: 32px;
      height: 32px;
      background: url("@/assets/img/icons/filter.png") no-repeat center / cover;

      margin-left: 10px;
    }
  }

  .emptyBox,
  .pageList,
  .van-pull-refresh {
    height: calc(100% - 52px - 70px - 66px);
    padding: 10px 18px;
    overflow-y: scroll;

    .customerItem {
      padding: 6px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      &:not(:last-child) {
        margin-bottom: 10px;
      }

      .up {
        padding: 8px 10px 10px;
        border-bottom: 1px solid #f2f2f2;

        .leftBox {
          .img {
            width: 42px;
            height: 42px;
            border-radius: 100%;

            margin-right: 11px;
          }

          .name {
            height: 25px;
            line-height: 25px;
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #333333;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          .gOrA {
            height: 20px;
            line-height: 20px;
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
        .iconBox {
          min-width: 28px;
          height: 28px;
          font-family:
            PingFang SC,
            PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #ff7123;
          text-align: right;
          font-style: normal;
          text-transform: none;

          .icon:not(:last-child) {
            margin-left: 8px;
          }
        }
      }
      .down {
        padding: 12px 10px 6px;

        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;

        div {
          height: 20px;
          line-height: 20px;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }

        .telephoneIcon {
          width: 28px;
          height: 28px;
        }
      }
    }
  }
}
</style>
